import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';

import { getRangeInTimezoneEndingNow, appTimezone } from '../support/dateUtils';

const PATH = '/v1/health-check';

const IsEventIngestionHealthy = new ReduxAsyncAction('IS_EVENT_INGESTION_HEALTHY');
IsEventIngestionHealthy.registerRequest(() => {
  return dash_api
    .post(`${PATH}/event-ingestion/is-healthy`, { timezone: appTimezone, ...getRangeInTimezoneEndingNow(1) })
    .then((res) => res.data);
});

export const IS_EVENT_INGESTION_HEALTHY = IsEventIngestionHealthy.constants;
export const isEventIngestionHealthy = IsEventIngestionHealthy.request;

const DuplicateDataSources = new ReduxAsyncAction('DUPLICATE_DATA_SOURCES');
DuplicateDataSources.registerRequest(() => {
  return dash_api
    .post(`${PATH}/event-ingestion/duplicate-events`, { timezone: appTimezone, ...getRangeInTimezoneEndingNow(7) })
    .then((res) => res.data);
});

export const DUPLICATE_DATA_SOURCES = DuplicateDataSources.constants;
export const duplicateDataSources = DuplicateDataSources.request;
